import { Theme } from '@mui/material/styles'

const wrapperBoxStyle = (theme: Theme) =>
  ({ width: '100%', background: theme.palette.background.paper, marginBottom: { xs: '72px', md: '48px' } }) as const

const boxContentStyle = {
  height: {
    xs: '56px',
    md: '80px'
  },
  display: 'flex',
  maxWidth: '1440px',
  justifyContent: 'space-between',
  alignItems: 'center',
  px: {
    xs: '24px',
    md: '128px'
  },
  margin: '0 auto'
} as const

const iconButtonStyle = { height: '100%', padding: 0, outlineOffset: '-2px' } as const

const iconButtonContentStyle = (theme: Theme) =>
  ({
    display: 'block',
    height: {
      xs: '14px',
      md: '24px'
    },
    filter: theme.palette.mode === 'dark' ? 'invert(1)' : null
  }) as const

export { wrapperBoxStyle, boxContentStyle, iconButtonStyle, iconButtonContentStyle }
